module.exports = __webpack_public_path__ + "img/RegisterInterest-tick.1c3e0615.svg";